import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = {
  forward_id: string;
  enabled?: boolean;
  url?: string;
  event_types?: string[];
};

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useUpdateWebhookForwardMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while updating the webhook forward',
    endpoint: ({ forward_id }) => `/api/admin/whatsapp/webhook-forward/${forward_id}`,
    method: 'PUT',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
